export const dietaryPlans = {
  getDietaryPlans() {
    return this.httpInstance.get('/billing/dietaryPlansShopItems');
  },
};
